var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 44.5714H23.6572C23.4857 44.5714 6.85718 40.6286 6.85718 22.2857V12C6.85718 11.3143 7.20003 10.6286 7.88575 10.4571L23.3143 3.60001C23.8286 3.42858 24.3429 3.42858 24.6857 3.60001L40.1143 10.4571C40.8 10.6286 41.1429 11.3143 41.1429 12V22.2857C41.1429 40.6286 24.5143 44.5714 24.3429 44.5714H24ZM10.2857 13.0286V22.2857C10.2857 36.5143 21.7715 40.4571 24 41.1429C26.2286 40.4571 37.7143 36.6857 37.7143 22.2857V13.0286L24 6.85715L10.2857 13.0286Z",
    fill: "#04BA96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5715 30.857C20.0572 30.857 19.7144 30.6856 19.3715 30.3428L14.2286 25.1999C13.5429 24.5142 13.5429 23.4856 14.2286 22.7999C14.9144 22.1142 15.9429 22.1142 16.6286 22.7999L20.5715 26.7428L31.3715 15.9428C32.0572 15.257 33.0858 15.257 33.7715 15.9428C34.4572 16.6285 34.4572 17.657 33.7715 18.3428L21.7715 30.3428C21.4286 30.6856 21.0858 30.857 20.5715 30.857Z",
    fill: "#7A7B93"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/ShieldIcon.ed02f4873173d43b7fb1872fbe33632f.svg";
export { ForwardRef as ReactComponent };